<template>
  <div class="animated fadeIn">
    <b-card>
      <p class="h2">「{{ this.userid }}」の利用状況</p>
      <p> ユーザー別の利用状況を表示します。</p>
      <div>
      <form class="form-inline">
        <div class="form-group ">
          開始日
          <b-form-input v-model="starttime" type="date" style="font-size: 16px; margin-left: 8px;"></b-form-input>
        </div>
        <div class="form-group mx-sm-3">
          終了日
          <b-form-input v-model="endtime" type="date" style="font-size: 16px; margin-left: 8px;"></b-form-input>
        </div>
        <b-button variant="primary" @click="refresh()">
          <i class="fa fa-refresh"></i> 更新
        </b-button>
      </form>
      </div><br>
      <div>
        <table class="table-sm table-striped table-borderless">
          <thead style="border:solid 0px;">
            <tr>
              <th width="140">日時</th>
              <th>履歴</th>
            </tr>
          </thead>
          <tbody>
           <tr v-for="item in this.items" :key="item.time">
            <td>{{ item.time }}</td>
            <td>{{ item.text }}</td>
           </tr>
          </tbody>
        </table>
      </div>
      <div>
        <spinner v-show="isLoading" :line-size="4" :size="60" :speed="0.8" line-fg-color="#B23E53" style="margin:10px;"></spinner>
      </div>
    </b-card>
  </div>
</template>

<script>
import Store from '@/store'
import ApiAccess from '@/components/ApiAccess'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'UserInfoLog',
  props: ['userid'],
  mixins: [ ApiAccess ],
  components: {
    Spinner
  },
  data: () => {
    return {
      fields: {
        time: {
          label: '時間',
          sortable: false,
          width: '5px'
        },
        text: {
          label: '履歴',
          sortable: false
        }
      },
      items: [],
      currentPage: 1,
      perPage: 12,
      totalRows: 0,
      isLoading: false,
      searchFlg: false,
      serachInputText: '',
      searchText: '',
      starttime: '2018-07-01',
      endtime: '2018-07-31'
    }
  },
  created: function () {
    var startDate = new Date()
    var endDate = new Date()
    startDate.setDate(startDate.getDate() - 1)

    this.starttime = this.dateToString(startDate)
    this.endtime = this.dateToString(endDate)
    this.getDatas()
  },
  methods: {
    getDatas: async function () {
      this.isLoading = true
      try {
        var log = await this.$_Api_GetLogList(Store.state.token, this.userid, this.starttime, this.endtime)
        this.items = (log && log.data) ? log.data : []
      } catch (e) {
        console.error('getDatas failed:', e)
        this.items = []
      } finally {
        this.isLoading = false
      }
    },
    async refresh () {
      this.items.length = 0
      await this.getDatas()
    },
    dateToString (date) {
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + (date.getDate())).slice(-2)
      return date.getFullYear() + '-' + m + '-' + d
    }
  }
}
</script>

<style>
table{
  width: 100%;
}
th {
  background: #3e515b;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/home/UserInfoLog.vue